// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.amenities.RentalManagerUserPropertyAmenityWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyAmenityWebApiHandler_create,
  RentalManagerUserPropertyAmenityWebApiHandler_delete,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { ListingAlias, UserPropertyAmenityCreateResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

interface CreateParams {
  listingAlias: ListingAlias;
  text: string;
}
interface DeleteParams {
  amenityId: string;
}

export interface RentalManagerUserPropertyAmenityWebApiHandler_create_Args {
  getParams: CreateParams;
}

export type RentalManagerUserPropertyAmenityWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyAmenityCreateResponseWebDto,
  unknown,
  RentalManagerUserPropertyAmenityWebApiHandler_create_Args
>;

/**
 * Create a free text property amenity
 * @deprecated
 */
export const useRentalManagerUserPropertyAmenityWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyAmenityWebApiHandler_create_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyAmenityWebApiHandler_create_Args) =>
      RentalManagerUserPropertyAmenityWebApiHandler_create(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyAmenityWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyAmenityWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyAmenityWebApiHandler_delete_Args
>;

/**
 * Delete a free text property amenity
 * @deprecated
 */
export const useRentalManagerUserPropertyAmenityWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyAmenityWebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyAmenityWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyAmenityWebApiHandler_delete(args.getParams, httpClient),
  });
};
